import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { currency } from "@/lib/format";

const TIP_OPTIONS = [
    { pct: 15, label: "15%" },
    { pct: 18, label: "18%" },
    { pct: 20, label: "20%" },
    { pct: 25, label: "25%" },
];

export default function TipSelector({ subtotal, tipPct, customTip, onChangePct, onChangeCustomTip }) {
    const value = customTip ? "custom" : tipPct.toString();

    return (
        <Card className="mt-4">
            <CardContent className="p-6">
                <h2 className="font-display text-xl mb-3">Add a tip</h2>
                <RadioGroup
                    value={value}
                    onValueChange={(v) => {
                        if (v !== "custom") {
                            onChangeCustomTip("");
                            onChangePct(parseInt(v, 10));
                        }
                    }}
                    data-testid="tip-selector"
                >
                    <div className="grid grid-cols-4 gap-2">
                        {TIP_OPTIONS.map((opt) => (
                            <Label
                                key={opt.pct}
                                className={`cursor-pointer rounded-lg border border-border p-3 text-center ${
                                    tipPct === opt.pct && !customTip
                                        ? "bg-secondary border-[hsl(var(--brand-terracotta))]"
                                        : ""
                                }`}
                            >
                                <RadioGroupItem value={opt.pct.toString()} className="sr-only" data-testid={`tip-${opt.pct}`} />
                                <div className="font-medium">{opt.label}</div>
                                <div className="text-xs text-muted-foreground mt-0.5">
                                    {currency((subtotal * opt.pct) / 100)}
                                </div>
                            </Label>
                        ))}
                    </div>
                    <div className="mt-3">
                        <Label className="text-xs text-muted-foreground">Custom tip ($)</Label>
                        <Input
                            type="number"
                            min="0"
                            step="0.50"
                            placeholder="0.00"
                            value={customTip}
                            onChange={(e) => onChangeCustomTip(e.target.value)}
                            className="mt-1"
                            data-testid="custom-tip-input"
                        />
                    </div>
                </RadioGroup>
            </CardContent>
        </Card>
    );
}
